import emotion from 'emotion/dist/emotion.umd.min.js';

const { css } = emotion;

export const CtaContainer = css`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;

  @media (max-width: 600px) {
    padding: 40px;
  }
`;

export const Title = css`
  font-size: 30px;
  color: #fff;
`

